import React, { useState, useEffect } from "react";
import CustomFilters from "../../core/custom-filters";
import SiAutocomplete from "../../core/si-autocomplete";
import { HTTP_METHODS, plainApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { PAGE_LIMIT } from "../../utils";

const ActionFilters = ({ loadData, setMainFilters, filter }) => {
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [codeList, setCodeList] = useState([]);

  const applyFilters = (filters) => {
    if (Object.keys(filters).length) {
      const payload = {};
      for (let key in filters) {
        if (typeof filters[key] === "object" && filters[key]?.value) {
          payload[key] = filters[key].value;
        } else {
          payload[key] = filters[key];
        }
      }
      if (setMainFilters) {
        setMainFilters(payload);
      }
      loadData({
        ...payload,
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: filter?.page || 1,
        type: "action",
      });
    } else {
      if (setMainFilters) {
        setMainFilters({});
      }
      loadData({
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: filter?.page || 1,
        type: "action",
      });
    }
  };

  const filterTypes = [{ label: "Filter by Code", value: "code" }];
  const loadUserOptions = () => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.TICKETS}/codes`, null, {
      type: "ACTION",
    })
      .then((res) => {
        if (res.length) {
          const result = res?.map((ele) => ({
            label: ele.code,
            value: ele.code,
          }));
          setCodeList(result);
        }
      })
      .catch((err) => console.error(err));
  };

  const renderFilterInput = () => {
    switch (filterType) {
      case "code":
        return (
          <SiAutocomplete
            onChange={setFilterValue}
            options={codeList}
            placeholder="Search Code"
          />
        );

      default:
        return null;
    }
  };

  const handleFilterValueChange = (event) => {
    setFilterValue(event.target.value);
  };
  useEffect(() => {
    if (filterType === "code") {
      loadUserOptions();
    }
  }, [filterType]);
  return (
    <div>
      <CustomFilters
        applyFilters={applyFilters}
        renderFilterInput={renderFilterInput}
        filterTypes={filterTypes}
        filterType={filterType}
        setFilterType={setFilterType}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default ActionFilters;
